<template>
  <ais-toggle-refinement :label="label" :attribute="attribute">
    <template v-slot="{ value, refine, createURL, sendEvent }">
      <b-form-checkbox
        @input="refine(value)"
        :checked="value.isRefined"
      >
        {{ label }}
        <span v-if="!value.isRefined" class="badge badge-pill badge-primary">{{ value.count }}</span>
      </b-form-checkbox>
    </template>
  </ais-toggle-refinement>
</template>

<script>
export default {
  name: "StyledToggleRefinement",
  props: {
    label: String,
    attribute: String,
  }
}
</script>

<style scoped>

</style>
